<template>
    <v-row class="ma-2" no-gutters>
        <v-col cols="3" class="px-1">
            <v-btn small block class="leaderboard-tab-btn" :class="tab === 1 ? 'active-tab-btn' : 'tab-btn'"
                @click="setLeaderBoardTab(1)">
                All Time
            </v-btn>
        </v-col>
        <v-col cols="3" class="px-1">
            <v-btn small block class="leaderboard-tab-btn" :class="tab === 2 ? 'active-tab-btn' : 'tab-btn'"
                @click="setLeaderBoardTab(2)">
                Daily
            </v-btn>
        </v-col>
        <v-col cols="3" class="px-1">
            <v-btn small block class="leaderboard-tab-btn" :class="tab === 3 ? 'active-tab-btn' : 'tab-btn'"
                @click="setLeaderBoardTab(3)">
                Weekly
            </v-btn>
        </v-col>
        <v-col cols="3" class="px-1">
            <v-btn small block class="leaderboard-tab-btn" :class="tab === 4 ? 'active-tab-btn' : 'tab-btn'"
                @click="setLeaderBoardTab(4)">
                Monthly
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'LeaderboardSubNav',
    props: {
        tab: { type: Number, default: 1 }
    },
    setup(_, ctx) {
        
        const setLeaderBoardTab = (val) => {
            ctx.emit('change', val)
        }

        return {
            setLeaderBoardTab
        }
    }
}
</script>